export type CumulativeTimeAndIntensityDTO = {
  cumulativeRainfall: number
  maxIntensity: number
}

export class TimeStepCumulativeRainfallDTO {
  constructor(readonly timestamp: string, readonly cumulativeTimeAndIntensity?: CumulativeTimeAndIntensityDTO[]) {}
}
